import React, {FC} from 'react';

import {getHasPushV2} from '../../../../../libs/shared/core/src/services/push/common/pushSelectors';
import {useCommonAppSelector} from '../../../../../libs/shared/core/src/store/useCommonAppSelector';
import {useIsConnected} from '../../../../../libs/shared/ui/src/push/useIsConnected';
import {OfflineBanner} from '../../../app/banners/offline/offlineBanner';

export const DesktopOfflineBanner: FC = () => {
  const isConnected = useIsConnected();
  const isPushV2Enabled = useCommonAppSelector(getHasPushV2);
  if (isConnected || !isPushV2Enabled) {
    return null;
  }

  return <OfflineBanner />;
};
